import { getDataToCancel } from "features/orders/components/orders-cancel/utils";
import Fetch from "utils/fetch";

export const searchVariableStockPolicy = (idFamiliaRotuladaCentro) => {
  return Fetch.get(`/visaoEstoque/obterPoliticaEstoqueVariavel/${idFamiliaRotuladaCentro}`).then(({ data }) => data);
}

export const searchCardDetail = (idFamiliaRotuladaCentro, date, datetype) => {
  return Fetch.get(`/pedido/familiaRotuladaCentro/${idFamiliaRotuladaCentro}?date=${date ? date : ''}&dateType=${datetype ? datetype : 0}`).then(({ data }) => data);
}

export const checkSuggestionInconsistencies = (idUser, idFamiliaRotuladaCentro, materials) => {
  return Fetch.post(`/sugestoes/verificarInconsistenciasDaSugestao/${idUser}/${idFamiliaRotuladaCentro}`, { Sugestoes: materials }).then(({ data }) => data);
}

export const searchJustificationsRequestOnOver = () => {
  return Fetch.get(`/sugestoes/listaJustificativasPedidoEmOver`).then(({ data }) => data);
}

export const changeRequest = (alteracaoPedido) => {
  return Fetch.post(`/pedido/alterarPedidoVisaoEstoqueDetalhe`, alteracaoPedido).then(({ data }) => data);
}

export const saveSuggestion = (sugestao) => {
  return Fetch.post(`/suggestions:update`, sugestao);
}

export const deleteSuggestion = (sugestoes) => {
  return Fetch.delete(`/suggestions:remove`, { Sugestoes: sugestoes });
}

export const cancelBalance = (idItemVolume, body) => {
  return Fetch.post(`/volume-orders/${idItemVolume}:cancel`, body);
}

export const newManualSuggestion = (idFamiliaRotuladaCentro) => {
  return Fetch.get(`/sugestoes/criarNovaSugestaoManual/${idFamiliaRotuladaCentro}`).then(({ data }) => data);
}

export const cancelOrder = (order, forcedCancel, note) => {
  const request = getDataToCancel(order, forcedCancel, note);
  return Fetch.post(request.API, request.body);
};

export const applyProgrammingInStock = (idFamiliaRotuladaCentro) => {
  return Fetch.post(`/visaoEstoque/aplicarProgramacaoNoEstoque/${idFamiliaRotuladaCentro}`);
}

export const saveOverviewStockInformation = (visaoEstoqueInformacoes) => {
  Fetch.post(`/visaoEstoque/salvarVisaoEstoqueInformacoes/`, visaoEstoqueInformacoes).then(() => Promise.resolve());
}

export const createSuggestionByShelfLife = (idFamiliaRotuladaCentro, itemsShelfLifeCheckedData) => {
  Fetch.post(`shelfLife/criarSugestaoViaShelfLife/${idFamiliaRotuladaCentro}`, itemsShelfLifeCheckedData).then(() => Promise.resolve());
}

export const composicaoCargaCancel = (loadCompositionId, cancelamento) => {
  Fetch.post(`load-compositions/${loadCompositionId}:cancel`, cancelamento);
}

export const lastUpdateOfStock = (idFamiliaRotuladaCentro) => {
  return Fetch.get(`/visaoEstoque/obterUltimaAtualizacao/${idFamiliaRotuladaCentro}`).then(({ data }) => data);
}

export const requestOrderCancellation = (requestOrderCancellationDto) => {
  return Fetch.put(`/pedido/requestOrderCancellation`, requestOrderCancellationDto).then(
    ({ data }) => data
  );
};
